<template>
<div>
  <div class="comTitle">
        <p>专业设置</p>
        <span>sPECIALITIES</span>
        <em></em>
    </div>
  <div class="swiperRotationBox"  :style="{position: 'relative',height: styles.height+'rem'}" >
    <div class="swiper-container" :style="{width: styles.width + 'px',position: 'absolute',height: styles.height+'rem',left: '50%',marginLeft: '-3.75rem'}">
    <div class="swiper-wrapper" ref="swiper-wrapper">
         <div v-for="(item, index) in sliderData" :key="index"    class="swiper-slide" >
           <router-link :to="item.Url" :href="item.Url"  @click.native="OpenLink(item.Url)"   ><img :src="item.Cover"    />
            <div class="mianBox">
               <p class="title">【{{item.Title}}】</p>
               <p class="title2">{{item.Author}}</p>
               <!-- <p class="title_en">College education</p> -->
               <p class="title_en">{{item.Source}}</p>
               </div>  </router-link> 
       </div>
    </div>
    <!-- 如果需要分页器 -->
    <div class="swiper-pagination"></div>

    <!-- 如果需要导航按钮 -->
    <!-- <div  v-if="sliderData.length>1" class="swiper-button-prev" style="left: 50%; margin-left: -620px"></div>
    <div  v-if="sliderData.length>1" class="swiper-button-next" style="left: 50%; margin-left: 600px"></div> -->

    <!-- 如果需要滚动条 -->
    <!-- <div class="swiper-scrollbar"></div> -->
</div>
  </div>
  </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
export default {
  name: 'Rotation',
  props: {
   sliderData: { // 图片列表 src数组
      type: Array,
      default: () => []
    },
    isShowPosition: { // 是否显示下方小圆点
      type: Boolean,
      default: true
    },
    isShowLeftOrRightBtn: { // 是否显示左右按钮
      type: Boolean,
      default: true
    },
    duration: { // 切换间隔
      type: [Number, String],
      default: 5000
    },
    animationT: {
     type: Object,
     default: () => {
        return {
          speed: 20,
          speedTime: 20
        }
      }
    },
    styles: { // 自定义轮播图片宽高 默认500*300
      type: Object,
      default: () => {
        return {
          width: window.window.innerWidth,
          height: 4
        }
      }
    }
  },
  data () {
    return {
      active: 1, // 当前轮播图片
      timer: null,// 定时器
      len: 1,
      screenWidthtimer: false,
      screenWidth: window.window.innerWidth/7.5*5.9, // 屏幕宽度
    }
  },
  created(){
    // console.log(this.$refs.swiper-wrapper);
    setTimeout(()=>{
       this.init()
    },200)
   
  },
  methods:{
    init(){
      if(this.sliderData.length>1){
        var mySwiper = new Swiper ('.swiperRotationBox .swiper-container', {
            loop: true,
            watchSlidesProgress: true,
            slidesPerView: 'auto',
            initialSlide : 3,
            centeredSlides: true,
            // 如果需要分页器
            pagination: '.swiperRotationBox .swiper-pagination',
            // 如果需要前进后退按钮
          onProgress: function(slides, progress) {
          
            let  activeIndex = slides.activeIndex
              slides = slides.slides
              let modify=1
              for (var i = 0; i < slides.length; i++) {
                var slide = slides.eq(i);
                var slideProgress = slides[i].progress;
                var speet = (slide.index()-activeIndex)||0 ;
                // console.log(slide.index());
           
                speet<=1?speet=0: speet--
                modify = 1;
                if (Math.abs(slideProgress) > 1) {
                  modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
                }
               let translate = slideProgress * modify * 220 +speet*200+ 'px';
              let  scale = 1 - Math.abs(slideProgress) / (15-speet);
               let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
                slide.transform('translateX(' + translate + ') scale('+scale+')');
                slide.css('zIndex', zIndex);
                slide.css('opacity', 1);
                if (Math.abs(slideProgress) > 3) {
                  slide.css('opacity', 0);
                }
              }
            },
            onSetTransition: function(slides,transition) {
              slides= slides.slides
              for (var i = 0; i < slides.length; i++) {
                var slide = slides.eq(i)
                slide.transition(transition);
              }

            },
            nextButton: '.swiperBox .swiper-button-next',
            prevButton: '.swiperBox .swiper-button-prev',
        })
      }        
    }
  },
  
}
</script>
<style lang="less" scoped >
.swiperRotationBox{
  width: 100%;
  width: 7.5rem;
  padding-top: 0.4rem;
  padding-bottom:0.9rem;
  // overflow: hidden;
  .swiper-container{
    overflow:visible;
  }
   .swiper-button-prev,.swiper-button-next{
            display: none;
   }
   &:hover{
       .swiper-button-prev,.swiper-button-next{
            display: block;
       }
   }
 /deep/ .swiper-slide {
   width: 5.9rem;
   overflow: hidden;
  a{
    -webkit-transition: opacity 0.3s;
    transition: opacity 0.3s;
    height: 3.4rem;
    opacity: 0.99;
    padding-top: 0.3rem;
    display:block;
    position: relative;
    img{
      width: 100%;
    }
     .mianBox{
        position: absolute;
        top: 50%;
        width: 100%;
        //   -webkit-transition: all 0.3s;
        // transition: all 0.3s;
         margin-top: -1.8rem ;
        height: 3.5rem;
        padding: 0.25rem 0.2rem;
        // background: rgba(0,0,0,0.5);
        left: 0;
        .title{
          // width: 140px;
          height: 0.29rem;
          margin-left:-0.1rem;
          font-size: 0.3rem;
          line-height:1.2;
          color: #FFFFFF;
          letter-spacing: 0.02rem;
        }
        .title2{
          padding-top:0.2rem;
          height: 0.28rem;
          font-size: 0.28rem;
          line-height: 1.2;
          color: #FFFFFF;
        }
        .title_en{
          position: absolute;
          bottom: 0.4rem;
          right: 0.65rem;
          font-size: 0.22rem;
          line-height:1.2;
          letter-spacing: 0.01rem;
          color: #FFFFFF;
          // writing-mode:vertical-lr;
        }
     }

  }
   &.swiper-slide-active,&.swiper-slide-duplicate-active{
      a{
       padding-top: 0;
         opacity: 1;
        height: 4rem;
        // .mianBox {
        //     margin-top: -2rem ;
        // }
      }
   }
 }
 /deep/ .swiper-pagination {
   bottom: -0.4rem;
        .swiper-pagination-bullet{
         	width: 0.14rem;
			    height: 0.14rem;
        background: #7f8183;
          border-radius: 50%;
          opacity: 1;
          &.swiper-pagination-bullet-active{
          //  width: 0.4rem!important;
          //   height: 0.08rem!important;
							// width: 0.35rem;
                background: #0376be;
              // height: 0.14rem;
            // background: #0376be;
            opacity: 1;
            // border-radius: 0.3rem;
        }

      }
   }
}
</style>


// WEBPACK FOOTER //
// src/components/rotation.vue